import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";
import { useGetBlogsQuery, useDeleteBlogMutation } from "slices/cms/blogSlice";

function Blogs() {
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteBlogMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  // ✅ Fetch blogs with automatic refetch on focus/reconnect
  const { data, isLoading, refetch } = useGetBlogsQuery(
    { page, limit, search, type: "blog" },
    { refetchOnFocus: true, refetchOnReconnect: true },
  );

  const col = [
    { display: "Title", key: "title", type: "display" },
    {
      display: "Description",
      key: "description",
      type: "display",
      render: (row) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = row.description;
        const textContent = tempDiv.textContent || tempDiv.innerText || "";
        const truncated =
          textContent.length > 100
            ? textContent.slice(0, 100) + "..."
            : textContent;
        return <span title={textContent}>{truncated}</span>;
      },
    },
    {
      display: "Image",
      key: "authorImage",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
  ];

  const canEdit = hasActionAccess(auth, "CMS", "Blogs", "edit");
  const canDelete = hasActionAccess(auth, "CMS", "Blogs", "delete");

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleLimitChange = (event) => {
    const newLimit = event.target.value;
    setLimit(newLimit);
    setPage(1);
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    navigate(`/cms/blogs/update-blog/${row._id}`, { state: { refresh: true } });
  };

  const handleAdd = () => {
    navigate("/cms/blogs/add-blog");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      await del(id).unwrap();
      refetch(); // refetch after deletion
    }
  };

  const canAdd = hasActionAccess(auth, "CMS", "Blogs", "add");

  // ✅ Optional: refetch when navigated with state refresh flag
  useEffect(() => {
    if (location.state?.refresh) {
      refetch();
    }
  }, [location.state]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* {canAdd && (
        <Button
          onClick={handleAdd}
          style={{ background: "#fff", marginBottom: "1rem" }}
        >
          Add+
        </Button>
      )} */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        {canAdd && (
          <Button onClick={handleAdd} style={{ background: "#fff" }}>
            Add+
          </Button>
        )}

        <FormControl size="small" style={{ minWidth: 150 }}>
          <InputLabel>Limit</InputLabel>
          <Select
            value={limit}
            label="Blogs Limit"
            onChange={handleLimitChange}
            style={{ background: "#fff" }}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={500}>500</MenuItem>
          </Select>
        </FormControl>
      </div>

      <Tables
        title={"Blogs"}
        handleSearch={handleSearchChange}
        totalPages={data?.total}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
        loading={isLoading}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Blogs;
